module.exports = __webpack_public_path__ + "static/media/Reservation-06.867cdd4f.svg";